/** Erro devolvido pela API (ou falta de conexão), já com a mensagem pronta para o usuário. */
export class ErroApi extends Error {
  constructor(
    readonly status: number,
    readonly codigo: string,
    mensagem: string,
    readonly campos: { campo: string; mensagem: string }[] = [],
    readonly detalhes?: Record<string, unknown>,
  ) {
    super(mensagem);
    this.name = "ErroApi";
  }

  /** Mensagem do erro de um campo específico do formulário, se houver. */
  doCampo(campo: string): string | undefined {
    return this.campos.find((c) => c.campo === campo)?.mensagem;
  }
}

let csrfToken: string | null = null;
export function definirCsrf(token: string | null | undefined) {
  csrfToken = token ?? null;
}

type Metodo = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

export async function api<T>(caminho: string, metodo: Metodo = "GET", corpo?: unknown): Promise<T> {
  const headers: Record<string, string> = {};
  if (corpo !== undefined) headers["content-type"] = "application/json";
  if (metodo !== "GET" && csrfToken) headers["x-csrf-token"] = csrfToken;

  let resposta: Response;
  try {
    resposta = await fetch(`/api${caminho}`, {
      method: metodo,
      credentials: "same-origin",
      headers,
      body: corpo !== undefined ? JSON.stringify(corpo) : undefined,
    });
  } catch {
    throw new ErroApi(0, "SEM_CONEXAO", "Sem conexão com o servidor. Verifique a internet e tente de novo.");
  }

  const dados = await resposta.json().catch(() => null);
  if (!resposta.ok) {
    const e = dados?.erro;
    throw new ErroApi(
      resposta.status,
      e?.codigo ?? "ERRO",
      e?.mensagem ?? "Erro inesperado. Tente de novo.",
      e?.campos ?? [],
      e?.detalhes,
    );
  }
  return dados as T;
}

/** Monta a query string ignorando valores vazios. */
export function qs(parametros: Record<string, string | number | boolean | undefined | null>): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(parametros)) {
    if (v !== undefined && v !== null && v !== "") p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : "";
}
